import { actions as formActions } from 'react-redux-form';
import { getReferenceCodeByCountry } from 'utilities/multiLanguageHelper';
import apiURLBuilder from 'core/apiURLBuilder';
import Api from 'services/api';
import preLoaderActions from 'actions/preLoaderActions';
import stepsActions from 'actions/stepsActions';
import { recordEventStepSuccess } from 'utilities/uTagging';
import actionTypes from 'constants/actionTypes';
import { DEBIT_CARD_PIN } from 'constants/statusProcess';
import { goToErrorsView } from './errorViewNavigation';

const selectDebitCard = infoCardSelected => (dispatch, getState) => {
    const url = apiURLBuilder.getURL('debitCardsInformation');
    const accessToken = getState().userProfile.accessToken;
    const header = {
        Authorization: `Bearer ${accessToken}`,
        originCountry: getReferenceCodeByCountry().toUpperCase(),
    };
    const query = {
        standard: infoCardSelected.standard,
        subtype: infoCardSelected.subtype,
        type: infoCardSelected.type,
    };

    const payload = {
        header,
        query,
    };

    dispatch(preLoaderActions.showPreLoader());
    Api.post(url, payload).then(
        response => {
            if (response.body.status === 'OK') {
                dispatch(formActions.change('userProfile.status', DEBIT_CARD_PIN));
                dispatch({
                    type: actionTypes.UPDATE_CARD_INFO,
                    data: infoCardSelected,
                });
            } else {
                dispatch(goToErrorsView({ errorCode: response.body.status, errorMessage: url }));
            }
            dispatch(preLoaderActions.hidePreLoader());
        },
        error => {
            dispatch(preLoaderActions.hidePreLoader());
            dispatch(goToErrorsView({ errorCode: error?.status, errorMessage: url }));
        }
    );
};

const selectPinDebitCard = infoCardSelected => (dispatch, getState) => {
    const url = apiURLBuilder.getURL('debitCardsInformationPin');
    const accessToken = getState().userProfile.accessToken;
    const currentIndex = getState().steps.get('currentStep');
    const header = {
        Authorization: `Bearer ${accessToken}`,
        originCountry: getReferenceCodeByCountry().toUpperCase(),
    };
    const query = {
        standard: infoCardSelected.standard,
        subtype: infoCardSelected.subtype,
        type: infoCardSelected.type,
        pin: infoCardSelected.pin ? infoCardSelected.pin : '',
    };

    const payload = {
        header,
        query,
    };

    dispatch(preLoaderActions.showPreLoader());
    Api.post(url, payload).then(
        response => {
            if (response.body.status === 'OK') {
                const investmentType = getState().userProfile.investmentType;

                dispatch(
                    stepsActions.finalizeStep({
                        index: currentIndex,
                        finished: true,
                    })
                );

                dispatch(stepsActions.enableFinishedAndNextStep());
                dispatch(
                    stepsActions.changeCurrentStep({
                        index: currentIndex + 1,
                    })
                );

                recordEventStepSuccess(investmentType, '/onboarding/tarjeta-seleccionar', 'tu tarjeta a tu gusto', {
                    event_name: 'event_success',
                    action: 'success',
                    format: 'steps',
                    component: 'funnel',
                    element: 'card selection',
                });
            } else {
                dispatch(goToErrorsView({ errorCode: response.body.status, errorMessage: url }));
            }
            dispatch(preLoaderActions.hidePreLoader());
        },
        error => {
            dispatch(preLoaderActions.hidePreLoader());
            dispatch(goToErrorsView({ errorCode: error?.status, errorMessage: url }));
        }
    );
};

export default {
    selectDebitCard,
    selectPinDebitCard,
};
